export enum Domain {
  PLANNING = 'planning',
  CREW = 'crew',
  EVENTS = 'events',
}
